import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import Notification from '~/components/Notification';
import {Button, Stack} from '@customink/pigment-react';

/** @param {PropTypes.InferProps<typeof propTypes>} props - Component properties. */
export function FontOutlineUnsupported(props) {
  const {dismiss, confirm} = props;
  return (
    <Notification
      {...props}
      title={
        <span>
          Oops!
          <br />
          This font does not support
          <br />
          the Outline Text feature.
        </span>
      }>
      <p>To use the Outline Text feature, please choose a different font.</p>
      <Stack className="notification-stack">
        <Button
          size="large"
          className="notification-cta"
          variant="secondary"
          onClick={confirm}>
          Remove Outline
        </Button>
        <Button
          size="large"
          className="notification-cta"
          variant="link"
          onClick={dismiss}>
          Cancel
        </Button>
      </Stack>
    </Notification>
  );
}

const propTypes = {
  confirm: PropTypes.func,
  dismiss: PropTypes.func
};

FontOutlineUnsupported.propTypes = propTypes;

FontOutlineUnsupported.displayName = 'FontOutlineUnsupported';

import {bindActionCreators} from 'redux';
import {createStructuredSelector} from 'reselect';
import {confirm, dismiss} from '~/actions/NotificationActions';
import {getNotification} from '~/selectors/NotificationSelectors';

export function select(state) {
  return createStructuredSelector({
    notification: getNotification
  })(state);
}

export function actions(dispatch) {
  return bindActionCreators(
    {
      dismiss,
      confirm
    },
    dispatch
  );
}

export default connect(select, actions)(FontOutlineUnsupported);
